export default __webpack_public_path__ + "static/november-pro-black-0fd46f5aeebd8a84bcf4db8cfd5ca8ad.woff2";